// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3873fb3a","239":"673557a0","455":"d9c08a36","668":"4201d93f"}[chunkId] + ".chunk.js";
};